import { createAction, props } from '@ngrx/store';

export const setComisionAction = createAction(
  '[COMISION] Set COMISION',
  props<{ comision: number }>()
);